module.exports = ":host {\r\n    font-family: Arial, Helvetica, sans-serif;\r\n}\r\nh3 {\r\n    cursor: pointer;\r\n}\r\n/* div {\r\n  width: 650px;\r\n} */"